/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetOrdersPublicIdQueryResponse, GetOrdersPublicIdPathParams, GetOrdersPublicId400 } from "../entities/GetOrdersPublicId";

function getGetOrdersPublicIdUrl(public_id: GetOrdersPublicIdPathParams["public_id"]) {
  const res = { method: 'GET', url: `/orders/${public_id}` as const }  
  return res
}

/**
 * @description Получение заказа
 * @summary Получение заказа
 * {@link /orders/:public_id}
 */
export async function getOrdersPublicId(public_id: GetOrdersPublicIdPathParams["public_id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetOrdersPublicIdQueryResponse, ResponseErrorConfig<GetOrdersPublicId400>, unknown>({ method : "GET", url : getGetOrdersPublicIdUrl(public_id).url.toString(), ... requestConfig })  
  return res.data
}